export const LOGIN_WITH_EMAIL = 'LOGIN_WITH_EMAIL';
export const LOGOUT = 'LOGOUT';
export const VERIFY_ROLE = 'VERIFY_ROLE';
export const SIGNUP_WITH_EMAIL = 'SIGNUP_WITH_EMAIL';
export const RESET_PASSWORD = 'RESET_PASSWORD';
